module.exports = __webpack_public_path__ + "img/red-1-squiggly-open.eb05f3e6.svg";